<script setup lang="ts">
import { required, email } from '@vuelidate/validators'
import type { VuelidateParserParams } from '~~/composables/useVuelidateParser'

definePageMeta({
  middleware: 'guest',
  title: 'Get help logging in',
})

const route = useRoute()
const hasInitError = ref(false)
const { auth } = useSupabaseClient()

const loadingText = ref('Loading')
const initCheckToken = async () => {
  const routeHash = route.hash
  if (/(?:type)/gim.test(routeHash))
    return (loadingText.value = 'Verifying Token')
  else if (/(?:error)/gim.test(routeHash)) hasInitError.value = true
  loadingText.value = ''
}

const formFieldsDefinition: VuelidateParserParams = [
  { key: 'email', value: '', rules: { required, email } },
]
const handleTokenRequest = async (formData: any) => {
  const { error } = await auth.resetPasswordForEmail(formData.email, {
    redirectTo: `${
      useRuntimeConfig().public.appUrl
    }/login/confirm?next=/dashboard/profile/password`,
  })
  if (error)
    throw (
      error?.toString()?.replace('AuthApiError:', '') ??
      'Error sending reset token email.'
    )
}
const onSubmitSuccess = () => {
  successMessage.value =
    'Password reset link sent successfully. Please check your email.'
}
const { v$, submitForm, canSubmit, successMessage } = useFormUtils({
  vuelidate: formFieldsDefinition,
  hooks: {
    onInit: initCheckToken,
    onSubmit: handleTokenRequest,
    onSubmitSuccess: onSubmitSuccess,
  },
})
</script>
<template lang="pug">
div
  OnboardingContainer(v-if="!loadingText")
    HeaderPublic(:show-login="true")

    h1(class="heading-2 mb-18") {{ hasInitError ? 'Token Invalid' : 'One-time login' }}
    p(class="heading-6 mb-36" v-if="!hasInitError") A one-time "magic" link will be sent to your email, allowing you to login and change your password.
    div(v-if="hasInitError") An invalid or expired verification token was provided.

    form(@submit.prevent="submitForm")
      div(class="flex flex-row gap-9")
        UiInput(
          v-model="v$.email.$model"
          type="email"
          placeholder="Company Email"
          autocomplete="email"
          :error="v$.email.$errors[0]?.$message"
        )
        button(
          class="btn btn-primary"
          type="submit"
          :disabled="!canSubmit"
        )
          span Send
          MaterialSymbol arrow_right_alt

  div(v-if="loadingText")
    progress(class="progress w-full")
    span(class="text-center") {{ loadingText }}
</template>
